module.exports = __webpack_public_path__ + "img/control_board.4eb0095d.jpg";